import { css } from "styled-components"

const PostContentStyle = css`
  p, h1, h2, h3, h4, h5, h6 {
    line-height: 2;
    color: ${({ theme }) => theme.text.post};
    letter-spacing: .01em;
  }
  p {
    margin: 30px 0 60px;
    font-size: 17px;
    text-align: justify;
  }
  h2 {
    margin: 60px 0 20px;
    border-bottom: solid 3px ${({ theme }) => theme.primary.main};
    font-size: 1.75em;
    font-weight: 600;
  }
  h3 {
    margin: 60px 0 30px;
    padding-left: 15px;
    border-left: solid 5px ${({ theme }) => theme.primary.main};
    font-size: 1.5em;
    font-weight: 600;
  }
  h4 {
    margin: 60px 0 30px;
    font-size: 1.35em;
    font-weight: 700;
  }
  h5 {
    margin: 60px 0 30px;
    font-size: 1.1em;
    font-weight: 600;
  }

  ul, ol {
    margin: 15px;
    padding-left: 1.5em;
    color: ${({ theme }) => theme.text.post};
    li {
      line-height: 1.75em;
      p {
        margin: 0;
      }
      ::marker {
        color: ${({ theme }) => theme.primary.main};
      }
    }
  }

  ul {
    li {
      margin: 5px;
      list-style: disc;
      ::marker {
        font-size: 1.5em;
      }
    }
  }

  ol {
    counter-reset: number 0;
    li {
      margin: 10px;
      padding-left: 5px;
      list-style: decimal;
      ::marker {
        font-size: 1.35em;
      }
    }
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: 600;
  }

  del {
    text-decoration: line-through;
  }

  p > code {
    display: inline-block;
    padding: .5px 5px !important;
    border-radius: 3px;
    background: ${({ theme }) => theme.code.background};
    color: ${({ theme }) => theme.code.text};
    font-size: 15px;
    font-family: Consolas, Menlo, Monaco, -apple-system, BlinkMacSystemFont, "Segoe UI", Meiryo, monospace;
  }

  a {
    color: ${({ theme }) => theme.primary.dark};
    text-decoration: none;

    :hover {
      text-decoration: underline;
    }
  }

  samp {
    display: inline-block;
    font-size: .8em;
    font-weight: 600;
    font-family: inherit;
    vertical-align: middle;
  }

  table {
    position: relative;
    width: 100%;
    margin: 60px 0 30px;
    border-collapse: collapse;
    line-height: 1.5;
  }
  caption {
    margin-bottom: 5px;
    text-align: left;
    font-size: 1.25em;
    font-weight: 500;
  }
  table th, table td {
    border: solid 1px ${({ theme }) => theme.primary.main};
  }
  thead {
    
  }
  tbody {
    color: ${({ theme }) => theme.text.post};
  }
  tr {

  }
  th {
    padding: 10px;
    background: ${({ theme }) => theme.primary.main};
    color: rgba(0, 0, 0, .87);
    font-weight: bold;
  }
  td {
    padding: 10px;
    text-align:center;
  }

  pre {
    /* user-select: all; */
    ::-webkit-scrollbar{
      height: 6px;
    }

    ::-webkit-scrollbar-track{
      background: 0 0
    }

    ::-webkit-scrollbar-thumb{
      background: #a1a1a4;
      border-radius: 6px;
    }
  }

  img {
    margin: 10px 0 25px;
    ${({ theme }) => theme.img.filter};
  }

  hr {
    margin: 60px 0;
    border-right: none;
    border-left: none;
    border-bottom: none;
    border: solid 0.75px ${({ theme }) => theme.primary.main};
  }
  
  aside {

  }

  blockquote {
    position: relative;
    margin: 60px 0 30px;
    padding: 30px;
    border-radius: 5px;
    background: ${({ theme }) => theme.blockquote.background};
    p {
      margin: 0;
      color: ${({ theme }) => theme.blockquote.text};
      font-size: 0.95em;
    }
    ::after {
      position: absolute;
      display: inline-block;
      top: 15px;
      left: 15px;
      font-size: 20px;
      content: "🔗";
    }
  }

  kbd {

  }

  /* mark {
    background: ${({ theme }) => theme.Marker.color};;
    font-weight: bold;
  } */

  b {
    font-weight: bold;
  }
`

export default PostContentStyle